var exports = {
  "p_": "TimelineList.module__list___LUFLNl",
  "AS": "TimelineList.module__item___LUFLNl",
  "Qq": "TimelineList.module__text___LUFLNl",
  "j9": "TimelineList.module__clamped___LUFLNl",
};

module.exports = exports;
